import {registerLocaleData} from "@angular/common";
import {EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer} from "@angular/core";
import {DateAdapter, MAT_DATE_LOCALE} from "@angular/material/core";
import {provideTranslateService, TranslateService} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import moment, {locale as setMomentLocale} from "moment";
import {STORAGE_LANGUAGE_KEY} from "./services/constants";
import {TranslateMomentAdapter} from "./services/translate/translate-moment-adapter";

import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';

import "moment/locale/de";
import "moment/locale/en-gb.js";

const FALLBACK_LANG = "de";

export const provideTranslate: () => EnvironmentProviders = () => makeEnvironmentProviders([
    provideTranslateService({
        fallbackLang: FALLBACK_LANG,
        loader: provideTranslateHttpLoader({prefix: "./assets/i18n/", suffix: ".json"}),
    }),
    {
        provide: DateAdapter,
        useClass: TranslateMomentAdapter,
        deps: [MAT_DATE_LOCALE],
    },
    provideAppInitializer(() => {
        const translateService = inject(TranslateService);
        translateService.addLangs(["de", "en"]);
        const preferredLang = localStorage.getItem(STORAGE_LANGUAGE_KEY) ?? navigator.language.split("-")[0];
        translateService.use(translateService.getLangs().includes(preferredLang) ? preferredLang : FALLBACK_LANG);
        translateService.onLangChange.subscribe(lang => setMomentLocale(lang.lang));
        // eslint-disable-next-line import-x/no-named-as-default-member
        moment.updateLocale('en', {
            week: {
                dow: 1
            }
        });
        registerLocaleData(localeDe);
        registerLocaleData(localeEn);
    }),
]);
